const MAP_ASSET_URI: Record<string, string> = {
  test: 'https://int.assets.oneweb.mercedes-benz.com/plugin',
  int1: 'https://int.assets.oneweb.mercedes-benz.com/plugin',
  pprod: 'https://assets.oneweb.mercedes-benz.com/plugin',
  prod: 'https://assets.oneweb.mercedes-benz.com/plugin',
};

export const getAssetSrc = (env: string, path: string) =>
  `${MAP_ASSET_URI[env] || MAP_ASSET_URI.test}/hp-assets/latest/${path}`;
